import React from 'react';
import './EventAbout.css';

const EventAbout = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Innovators:',
                topics: [
                    'Innovation Architecture',
                    'ChatGPT',
                    'FinOps',
                    'GitHub Copilot',
                    'Future of Arcitecture (WebAssembly, Unified Blazor & others)',
                ],
            },
            {
                title: 'Early Adopters:',
                topics: [
                    'Micro Frontends',
                    'ML & MLOps',
                    'AI Tools',
                    'Blockchain',
                    'Clean Architecture',
                    'Sustainability',
                    'Data Mesh',
                    'Cloud technologies',
                    'Web3',
                    'gRPC',
                ],
            },
            {
                title: 'Architecture of Today:',
                topics: [
                    'Service Mesh',
                    'Event-Driven Architecture',
                    'Cost Management',
                    'Microservices',
                    'Serverless',
                    'Kubernetes',
                ],
            },
            {
                title: 'Best Practices:',
                topics: [
                    'Asynchronous System Design',
                    'JS Frameworks',
                    'UI Architecture',
                    'Domain-Driven Design',
                    'DevOps',
                    'Archi Documentation',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <p className='getReady_item--title'>{item.title}</p>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li key={`getReady_li-${i + item}`} className='getReady_li'>{item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className="getReady_wrap">
            <div className='container getReady'>
                <h2 className='getReady_title'>What's inside</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default EventAbout;